export default {
  type: "locations",
  name: null,
  is_municipal: false,
  location_code: null,
  excerpt: "",
  relationshipNames: ["organization", "manager", "contacts"],
  organization: {
    type: "organizations",
    id: null,
  },
  manager: {
    type: "users",
    id: null,
  },
  contacts: [],
};
